var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { alpha } from "@material-ui/core/styles/colorManipulator";
// eslint-disable-next-line no-restricted-imports
import { common } from "@material-ui/core/colors";
import { deepmerge } from "@material-ui/utils";
import muiCreatePalette from "@material-ui/core/styles/createPalette";
var offBlack = "#141414";
var darkColors = {
    background: {
        default: offBlack,
        paper: "#272727",
        overlays: "#3A3A3A",
    },
    secondary: {
        main: "#3A3A3A",
    },
    divider: alpha(common.white, 0.16),
    dividerStrong: alpha(common.white, 0.32),
    text: {
        primary: common.white,
        secondary: alpha(common.white, 0.72),
    },
    action: {
        active: alpha(common.white, 0.24),
        hover: alpha(common.white, 0.16),
        focus: alpha(common.white, 0.16),
        selected: alpha(common.white, 0.08),
    },
};
var lightColors = {
    background: {
        default: common.white,
        paper: "#F2F2F2",
        overlays: common.white,
    },
    secondary: {
        main: "#E6E6E6",
    },
    divider: alpha(offBlack, 0.16),
    dividerStrong: alpha(offBlack, 0.32),
    text: {
        primary: offBlack,
        secondary: alpha(offBlack, 0.72),
    },
    action: {
        active: alpha(offBlack, 0.24),
        hover: alpha(offBlack, 0.16),
        focus: alpha(offBlack, 0.16),
        selected: alpha(offBlack, 0.08),
    },
};
var getDefaultColors = function (type) {
    return deepmerge({
        type: type,
        primary: {
            main: "#0074E4",
            light: "#339BFF",
        },
        success: {
            main: "#0B873A",
            light: "#11CF59",
        },
        warning: {
            main: "#FFA640",
            light: "#FFCB8F",
            contrastText: common.black,
        },
        error: {
            main: "#DE3341",
            light: "#E97780",
        },
        info: {
            main: "#6C5BB7",
            light: "#9D91CF",
        },
        common: { offBlack: offBlack },
        action: {
            hoverOpacity: 0.16,
            focusOpacity: 0.16,
            selectedOpacity: 0.08,
            disabledOpacity: 0.5,
            activatedOpacity: 0.24,
            contrastOpacity: 0.32,
        },
    }, type === "dark" ? darkColors : lightColors, { clone: false });
};
export var createPalette = function (_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.type, type = _b === void 0 ? "dark" : _b, options = __rest(_a, ["type"]);
    return muiCreatePalette(deepmerge(getDefaultColors(type), options, { clone: false }));
};
//# sourceMappingURL=createPalette.js.map